import React from 'react';
import * as RadixDialog from '@radix-ui/react-dialog';
import { H3 } from '../Typography';
import styles from './Dialog.module.css';

export const Dialog = ({ children, open, onOpenChange, title }: any) => {
  return (
    <RadixDialog.Root open={open} onOpenChange={onOpenChange}>
      <RadixDialog.Portal>
        <RadixDialog.Overlay className={styles.DialogOverlay} />
        <RadixDialog.Content className={styles.DialogContent}>
          <RadixDialog.Title className={styles.DialogTitle}>
            <H3>{title}</H3>
          </RadixDialog.Title>
          {children}
        </RadixDialog.Content>
      </RadixDialog.Portal>
    </RadixDialog.Root>
  );
};
